import { ComponentChildren, createContext, JSX } from 'preact'
import { useMemo } from 'preact/hooks'

export interface WidgetContextValue {
  widgetId: number
}

type Props = {
  children: ComponentChildren
  widgetId: number
}

export const WidgetContext = createContext<WidgetContextValue | undefined>(undefined)

export function WidgetProvider({ children, widgetId }: Props): JSX.Element | null {
  const contextValue = useMemo(() => ({ widgetId }), [widgetId])
  return <WidgetContext.Provider value={contextValue}>{children}</WidgetContext.Provider>
}
